// extracted by mini-css-extract-plugin
export var accordion = "_ii-0";
export var chevron = "_ii-3";
export var closed = "_ii-2";
export var content = "_ii-4";
export var open = "_ii-1";
export var rotate = "_ii-5";